import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { createContextHook } from "./utilities";
var ref = _sliced_to_array(createContextHook({
    displayName: "Version"
}), 2);
export var context = ref[0], use = ref[1];
var ProviderState = function(param) {
    var children = param.children;
    var ref = useState(null), version = ref[0], setVersion = ref[1];
    var ref1 = useState(null), commit = ref1[0], setCommit = ref1[1];
    useEffect(function() {
        if (version && commit) {
            return;
        }
        _async_to_generator(function() {
            var response, ref, version, commit, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetch("/version")
                        ];
                    case 1:
                        response = _state.sent();
                        if (response.status !== 200) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        ref = _state.sent(), version = ref.version, commit = ref.commit;
                        setVersion(version);
                        setCommit(commit);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, []);
    return /*#__PURE__*/ _jsx(context.Provider, {
        value: {
            commit: commit,
            version: version
        },
        children: children
    });
};
export default ProviderState;
